module.exports = __webpack_public_path__ + "static/media/efllogo.2e9aac95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/efllogo.svg
// module id = 97
// module chunks = 0